import QubitroDashboard from "../../../../docs/_images/qubitro-dashboard.png";
import * as React from 'react';
export default {
  QubitroDashboard,
  React
};